<template>
  <div class="quantity-component" v-bind:class="{ 'max-q' : showMaxQuantity }">
    <input class="form-control quantity-input" type="number" :value="value" min="1" :max="maxStock" placeholder="0" @keypress="onlyNumbers" @keydown="onKeyDown" @paste.prevent @input="onInput" />
    <small class="mini" v-if="showMaxQuantity">Max: {{ maxStock }}</small>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true
    },
    maxStock: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      showMaxQuantity: false,
    }
  },

  methods: {
    onlyNumbers(event) {
      const char = event.key;

      // Permitir solo números (0–9)
      if (!/^[0-9]$/.test(char)) {
        event.preventDefault();
      }
    },

    onKeyDown(e) {
      const nextValue = Number(`${this.value ?? ''}${e.key}`)
      if (!isNaN(nextValue) && nextValue > this.maxStock) {
        e.preventDefault();
        this.showMaxQuantity = true;
      }else {
        this.showMaxQuantity = false;
      }
    },

    onInput(event) {
      // this.value = this.value.replace(/\D/g, '');
      // this.$emit('input', Number(event.target.value));

      const val = event.target.value;

      if (val === '') {
        this.$emit('input', 0);
        return
      }

      this.$emit('input', Number(val));
    },
  }
}
</script>